import instance from './instance'
import API from '@api'

//包裹请求方法的容器
const http = {};

//service循环遍历输出不同的请求方法
for (let [key, api] of Object.entries(API)) {
  http[key] = (params={}, config={}) => {
    config.apiKey = key;
    const prefix = api.prefix || "adm/v3";
    let url = `${prefix}/${api.url}`;
    //不同请求的判断
    if (api.method === 'put' || api.method === 'post' || api.method === 'patch') {
      params = dealParams(params);
      return instance[api.method](url, params, config);
    } else if (api.method === 'delete' || api.method === 'get') {
      config.params = params;
      return instance[api.method](url, config);
    }
  }
}

// 处理params
export function dealParams(params) {
  let newParams = new FormData();
  for (let [key, val] of Object.entries(params)) {
    if (Array.isArray(val)) {
      val.forEach(value => newParams.append(key, value));
    } else {
      newParams.append(key, val);
    }
  }
  return newParams
}

export default http;